<template>
  <div id="app" :class="[theme, appStore]">
    <div class="header">
      <a target="_blank" href="https://www.tokenpocket.pro/?from=rex">
        <img v-if="theme === 'light'" class="logo" src="./assets/image/logo-light.png" />
        <img v-else class="logo" src="./assets/image/logo.png" />
      </a>
      <span class="title">| REX</span>

      <!-- <a href="https://bos-rex.tokenpocket.pro/" class="change-bc">
      <span>{{$t('i18nView.switchto')}}</span>-->
      <!-- <i class="iconfont icon-eos pc-only"></i> -->
      <!-- <span>BOS</span> 
      </a>-->

      <span class="lang-switch">
        <a v-if="this.$i18n.locale === 'zh'" @click="changeLang('en')" href="javascript:;">En</a>
        <a v-else @click="changeLang('zh')" href="javascript:;">中</a>
      </span>

      <ul class="nav-icon">
        <li>
          <a href="https://t.me/tokenPocket_en" target="_blank">
            <i class="iconfont icon-telegram"></i>
          </a>
        </li>
        <li>
          <a href="https://twitter.com/TokenPocket_TP" target="_blank">
            <i class="iconfont icon-twitter"></i>
          </a>
        </li>
        <li>
          <a href="https://medium.com/@tokenpocket.gm" target="_blank">
            <i class="iconfont icon-medium"></i>
          </a>
        </li>
        <!-- <li>
          <a href="javascript:void(0)" target="_blank">
            <i class="iconfont icon-wechat"></i>
          </a>
        </li>-->
      </ul>
    </div>

    <router-view />
  </div>
</template>

<script>
import { Settings } from "luxon";
import u from "underscore";

export default {
  name: "App",
  data() {
    return {
      theme: "dark",
      appStore: ""
    };
  },
  created() {
    let query = location.search.substr(1);
    let queryObj = {};
    if (query) {
      u.each(query.split("&"), item => {
        let tempArr = item.split("=");
        queryObj[tempArr[0]] = tempArr[1];
      });
    }

    if (queryObj["theme"] && queryObj["theme"] === "light") {
      this.theme = "light";
    }

    if (queryObj["store"] && +queryObj["store"] === 1) {
      this.appStore = "app-store";
    }
  },
  methods: {
    changeLang(lang) {
      this.$i18n.locale = lang;
      localStorage.setItem("locale", lang);
      if (lang === "en") {
        Settings.defaultLocale = "en-US";
      } else {
        Settings.defaultLocale = "zh-CN";
      }
    }
  }
};
</script>

<style lang="less">
#app {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe WPC", "Segoe UI",
    "HelveticaNeue-Light", "Ubuntu", "Droid Sans", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  padding: 0 20px;
  box-sizing: border-box;
  width: 100%;
  max-width: 1840px;
  margin: 0 auto 0;
  font-size: 13px;
  overflow: hidden;
}

.logo {
  height: 40px;
  vertical-align: middle;
  display: inline-block;
}

.title {
  display: inline-block;
  vertical-align: middle;
  font-weight: bold;
  line-height: 30px;
}

a {
  text-decoration: none;
}

.lang-switch {
  float: right;
  display: inline-block;
  font-weight: bold;
  line-height: 40px;
}

.lang-switch a {
  line-height: 30px;
  padding: 0 2px;
  font-size: 16px;
}

.nav-icon {
  list-style: none;
  float: right;
  margin: 0;
  padding: 0;
  line-height: 40px;
  margin-right: 30px;

  li {
    float: left;
    margin-left: 20px;
  }
  i {
    font-size: 18px;
  }
}

html,
body {
  padding: 0;
  margin: 0;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  margin: 8px 0;
  line-height: 1.5;
  font-size: 13px;
}

button,
.button {
  outline: none;
  -webkit-appearance: none;
  border: 1px solid;
  vertical-align: middle;
  background: transparent;
  display: inline-block;
  padding: 5px 8px;
  border-radius: 3px;
  line-height: 1.5;
  cursor: pointer;
}

.fr-label {
  display: block;
  width: 90%;
  text-align: right;
}

.header {
  font-size: 20px;
  margin: 10px auto;
}

.list-header {
  h1 {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
}

hr {
  border: none;
  margin: 20px 0;
}

h2 {
  font-size: 18px;
  margin-bottom: 20px;
}

input[type="text"],
input[type="number"] {
  width: 100px;
}

h3 {
  font-size: 14px;
}

p {
  margin: 12px 0;
  line-height: 20px;
}

.col-2,
.col-4,
.col-5,
.col-6,
.col-8 {
  display: inline-block;
  box-sizing: border-box;
  float: left;
  padding: 0 5px;

  &:first-child {
    padding-left: 0;
  }

  &:last-child {
    padding-right: 0;
  }
}

.col-2 {
  width: 25%;
}

.col-5 {
  width: 41.66%;
}

.col-4 {
  width: 37.5%;
}

.col-8 {
  width: 67%;
}

.col-6 {
  width: 50%;
}

/* fix public style */
.vote-content img {
  width: 100%;
}

.color-red {
  color: #d24f59;
}

#app {
  .btn-group {
    margin: 0;
  }
  .btn-group,
  .dropdown-menu,
  .dropdown-toggle {
    min-width: 70px;
  }
  .dropdown-toggle {
    font-weight: bold;
    background: none;
  }

  .dropdown-toggle:hover {
    background: transparent;
  }

  .dropdown-menu > li > a {
    padding: 5px 15px;
    text-shadow: none;
    font-weight: bold;
  }
  .caret {
    top: 8px;
    margin-left: 4px;
  }

  .vdatetime {
    input {
      width: 100%;
      line-height: 1.5;
      padding: 4px 8px;
      box-sizing: border-box;
      border-radius: 3px;
      -webkit-appearance: none;
      border: none;
      font-size: 14px;
    }
  }

  .vdatetime-popup {
    text-shadow: none;
  }

  h1 {
    font-size: 24px;
    margin: 20px 0 10px;

    i {
      font-size: 20px;
      padding-right: 5px;
      display: inline-block;
    }
  }
}

.change-bc {
  cursor: pointer;
  line-height: 18px;
  font-size: 12px;
  display: inline-block;
  vertical-align: middle;
  margin-left: 10px;
  padding: 5px;
  border-radius: 5px;

  span,
  i {
    display: inline-block;
  }
}

h2 {
  i.iconfont {
    font-size: 16px;
  }
  span {
    display: inline-block;
    vertical-align: middle;
  }
}

.iconfont {
  font-size: 13px;
  vertical-align: middle;
}

button i.iconfont {
  font-size: 12px;
}

.account {
  position: absolute;
  float: right;
  right: 0;
}

h3 {
  color: #4d78e2;
  border-left: 4px solid #4d78e2;
  padding-left: 10px;
  line-height: 1.2;
}

h4 {
  margin-top: 20px;
}

input {
  border-radius: 2px;
  border: none;
  line-height: 28px;
  display: inline-block;
  vertical-align: middle;
  padding-left: 8px;
}

input[type="radio"] {
  margin: 4px 8px;
}

.card {
  // background: linear-gradient(135deg, #555865, #3c3e48);

  padding: 10px 15px 20px 20px;
  margin-bottom: 10px;
  border-radius: 2px;
  overflow-x: auto;
  // box-shadow: 0 4px 10px #333;
}

.row::after {
  content: "";
  display: block;
  clear: both;
}

.card {
  .col-6 {
    &:last-child {
      border-right: none;
    }
  }
}

.common-tips {
  font-size: 12px;
}
.mobile-only {
  display: none !important;
}
.banner.ad {
  width: 100%;
  opacity: 0.6;
  transition: opacity 1s;

  &:hover {
    opacity: 1;
  }
}

.tips {
  position: relative;
  // background: #444;

  padding: 8px 20px 22px;
  font-size: 12px;
  margin: 10px -15px 10px -20px;

  .close {
    font-size: 12px;
    text-decoration: underline;
    cursor: pointer;
    position: absolute;
    padding: 2px 4px;
    right: 0;
    bottom: 0px;
  }
}

@media screen and (max-width: 1366px) {
  #app {
    min-width: 1340px;
  }

  .logo {
    height: 35px;
  }

  .header {
    font-size: 16px;
  }
}

@media screen and (max-width: 770px) {
  .mobile-only {
    display: block !important;
  }
  .pc-only {
    display: none !important;
  }

  #app {
    min-width: 300px;
    padding: 0 10px;
  }
  .logo {
    height: 30px;
  }

  .nav-icon,
  .lang-switch {
    line-height: 30px;
  }

  .nav-icon {
    margin-right: 10px;

    li {
      margin-left: 8px;
    }

    i {
      font-size: 16px;
    }
  }

  .header {
    font-size: 13px;
  }

  .account {
    display: none;
  }
  .col-2,
  .col-4,
  .col-5,
  .col-6,
  .col-8 {
    width: 100%;
  }

  .card {
    .col-6 {
      border-right: none;
      width: 50%;
    }
  }

  .col-2,
  .col-4,
  .col-5,
  .col-6,
  .col-8 {
    display: inline-block;
    box-sizing: border-box;
    float: left;
    padding: 0;

    &:first-child {
      padding-left: 0;
    }

    &:last-child {
      padding-right: 0;
    }
  }
}

@media screen and (max-width: 434px) {
  button.button {
    font-size: 12px;
  }

  .nav-icon {
    display: none;
  }

  .change-bc {
    margin-left: 2px;
    padding: 2px;
  }

  .lang-switch a {
    font-size: 14px;
  }
}

#app.dark {
  color: #fafafa;
  background-color: #171b2b;
  text-shadow: 0px 0px 3px #3a3a3a;

  a {
    color: #f1f1f1;
  }

  button,
  .button {
    color: #fafafa;
    box-shadow: 0 2px 5px #333;
  }

  hr {
    border-top: 1px dashed #444;
  }

  .dropdown-toggle {
    color: #f1f1f1;
  }

  .change-bc {
    border: 1px solid #ddd;
  }

  .card {
    background-color: #24293e;

    label {
      color: #fff;
    }
  }

  .common-tips {
    color: #ddd;
  }

  .tips {
    background: #1c2031;
    color: #ddd;
  }

  .tab.active {
    background: #24293e;
  }

  .pagination {
    border: 1px solid #fff;
  }

  .msg-modal {
    padding: 20px;
    background: #28282b;
    box-shadow: 0 2px 5px 2px #0a0b13;
  }
}

#app.light {
  color: #111;
  background-color: #fff;
  text-shadow: 0px 0px 3px #eee;

  a {
    color: #111;
  }

  button,
  .button {
    color: #111;
    box-shadow: 0 2px 5px #ddd;
  }

  hr {
    border-top: 1px dashed #ccc;
  }

  .dropdown-toggle {
    color: #111;
  }

  .change-bc {
    border: 1px solid #333;
  }

  .card {
    background-color: #f6f8fa;
    border: 1px solid #f1f1f1;

    label {
      color: #111;
    }
  }

  input {
    border: 1px solid #ddd;
  }

  .common-tips {
    color: #333;
  }

  .button.success,
  .button.danger {
    color: #fff;
  }

  .tips {
    background: #eef0f5;
    color: #333;
  }

  .tab.active {
    background: #f6f8fa;
  }

  .pagination {
    border: 1px solid #f1f1f1;
  }

  .msg-modal {
    padding: 20px;
    background: #f1f3f5;
    box-shadow: 0 2px 2px 0 #555;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue